module.exports = __webpack_public_path__ + "img/signs4.6f71827f.jpg";